<script setup lang="ts">
import { ref } from "vue";

const emit = defineEmits<{
  teleportToPosition: [positionId: string];
  teleportToCoordinates: [x: number, y: number, z: number];
}>();

// Reactive state
const inputValue = ref('');

// Validation functions
const isUUID = (input: string): boolean => {
  // Basic UUID validation regex
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  return uuidRegex.test(input);
};

const isCoordinates = (input: string): boolean => {
  // Matches {int}x{int}x{int}
  const coordRegex = /^\d+x\d+x\d+$/;
  return coordRegex.test(input);
};

// Main teleport handler
const handleTeleport = () => {
  const trimmedInput = inputValue.value.trim();

  // Check if input matches UUID format
  if (isUUID(trimmedInput)) {
    emit("teleportToPosition", trimmedInput);
  }
  // Check if input matches coordinates format
  else if (isCoordinates(trimmedInput)) {
    const [x, y, z] = trimmedInput.split("x").map(Number);
    emit("teleportToCoordinates", x, y, z);
  } else {
    console.error("Invalid input. Please provide a valid UUID or coordinates.");
  }
};
</script>

<template>
  <div class="gm-panel teleport-container">
    <div class="header">
      <h2 class="gm-section-title title">Teleport</h2>
    </div>

    <div class="teleport-content">
      <input
        v-model="inputValue"
        class="gm-input teleport-input"
        type="text"
        placeholder="Enter UUID or {x}x{y}x{z}"
      />
      <button class="gm-btn gm-btn--sm" @click="handleTeleport">
        Teleport
      </button>
    </div>
  </div>
</template>

<style scoped>
.teleport-container {
  display: flex;
  flex-direction: column;
}

.header {
  flex-shrink: 0;
}

.title {
  margin-bottom: var(--gm-gap-sm);
}

.teleport-content {
  display: flex;
  flex-direction: row;
  gap: var(--gm-gap-sm);
  align-items: center;
}

.teleport-input {
  flex: 1;
  min-width: 0;
}

@media (max-width: 640px) {
  .teleport-content {
    flex-direction: column;
    align-items: stretch;
  }
}
</style>
